module.exports = __webpack_public_path__ + "audio/blip.ogg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=audio/[name].ogg!./app/assets/audio/blip.ogg
// module id = 20
// module chunks = 0